import React from 'react';

import styles from './listing.scss';

const TabInfo = (props) => {
	return (
		<div className={`${styles['pending-text']}`}>
			<i className='icon-Info'></i>
			<div>
				<div className={styles['pending-status']}>
					{'Document Upload Pending'}
				</div>
				<div className={`info-text ${props.isSubtext ? 'reduce-pad' : ''}`}>
					{props.infoText}
				</div>				
			</div>
		</div>
	);
};

export default TabInfo;
